/* ══════════════════════════════════════════════════════
   OptiMind® Shopify Theme JS — theme.js
   v2.0 | MindRx LLC
   ══════════════════════════════════════════════════════ */

'use strict';

/* ── NAV SCROLL ── */
(function initNav() {
  const nav = document.getElementById('main-nav');
  if (!nav) return;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── MOBILE MENU ── */
(function initMobileMenu() {
  const btn  = document.querySelector('.mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    const open = menu.hidden;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  });
})();

/* ── REVEAL ON SCROLL ── */
(function initReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  els.forEach(el => io.observe(el));
})();

/* ── FAQ ACCORDIONS ── */
(function initFAQ() {
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item    = q.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });
})();

/* ── PRODUCT ACCORDIONS ── */
(function initAccordions() {
  document.querySelectorAll('.accordion-header').forEach(h => {
    h.addEventListener('click', () => h.closest('.accordion-item').classList.toggle('open'));
  });
})();

/* ── GALLERY THUMBNAILS ── */
(function initGallery() {
  const mainImg = document.getElementById('main-product-img');
  if (!mainImg) return;
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumb.dataset.img;
        mainImg.alt = thumb.dataset.alt || '';
        mainImg.style.opacity = '1';
      }, 200);
    });
  });
})();

/* ── PRODUCT VARIANT + SUBSCRIPTION LOGIC ── */
(function initProduct() {
  const productDataEl  = document.getElementById('product-data');
  const variantsDataEl = document.getElementById('product-variants');
  if (!productDataEl || !variantsDataEl) return;

  const variants       = JSON.parse(variantsDataEl.textContent);
  const variantBtns    = document.querySelectorAll('#variant-grid .variant-btn');
  const purchaseToggle = document.getElementById('purchase-toggle');
  const frequencyRow   = document.getElementById('frequency-row');
  // Two possible select IDs depending on Recharge mode:
  //   #frequency-select  → legacy mode (submits properties[shipping_interval_frequency])
  //   #selling-plan-select → native mode (UI dropdown that mirrors into hidden #selling-plan-input)
  const frequencySelect= document.getElementById('frequency-select');
  const sellingPlanSelect = document.getElementById('selling-plan-select');
  const isNativeRecharge = !!sellingPlanSelect;
  const priceMain      = document.getElementById('price-main');
  const priceOrig      = document.getElementById('price-orig');
  const priceSave      = document.getElementById('price-save');
  const priceNote      = document.getElementById('price-note');
  const atcBtn         = document.getElementById('atc-btn');
  const variantInput   = document.getElementById('variant-id-input');
  const sellingPlan    = document.getElementById('selling-plan-input');

  // Read subscription discount from data attribute (set by Liquid)
  const discountPct    = parseInt(document.querySelector('[data-subscription-discount]')?.dataset.subscriptionDiscount || '20');
  const multiplier     = (100 - discountPct) / 100;

  let currentVariantId = variants[0]?.id;
  let currentType      = 'subscription'; // default

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getVariant(id) {
    return variants.find(v => v.id === id) || variants[0];
  }

  function updatePrice() {
    const variant  = getVariant(currentVariantId);
    if (!variant) return;

    const isSub    = currentType === 'subscription';
    const rawPrice = variant.price; // in cents
    const subPrice = Math.round(rawPrice * multiplier);
    const savedAmt = rawPrice - subPrice;
    // Cadence label — in native Recharge mode, use the plan name; in legacy, use the day count.
    let freq = '30';
    let freqLabel = 'monthly';
    if (sellingPlanSelect) {
      const opt = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
      freqLabel = opt?.textContent.toLowerCase() || 'each delivery';
    } else if (frequencySelect) {
      freq = frequencySelect.value || '30';
      freqLabel = freq === '30' ? 'monthly' : `every ${freq} days`;
    }

    if (priceMain) priceMain.textContent = formatMoney(isSub ? subPrice : rawPrice);

    if (priceOrig) {
      priceOrig.style.display = isSub ? '' : 'none';
      priceOrig.textContent   = formatMoney(rawPrice);
    }
    if (priceSave) {
      priceSave.style.display = isSub ? '' : 'none';
      priceSave.textContent   = `You save ${formatMoney(savedAmt)}`;
    }
    if (priceNote) {
      priceNote.textContent = isSub
        ? `billed ${freqLabel} · free US shipping · cancel anytime`
        : `${variant.available ? 'free US shipping · 30-day guarantee' : 'Currently unavailable'}`;
    }

    // CTA button
    if (atcBtn) {
      if (!variant.available) {
        atcBtn.textContent = 'Sold Out';
        atcBtn.disabled    = true;
      } else if (isSub) {
        atcBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 6h12l-1.5 7.5H4.5L3 6z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="15" r="1" fill="currentColor"/><circle cx="12" cy="15" r="1" fill="currentColor"/><path d="M1 2h2l.5 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg> Subscribe &amp; Save — ${formatMoney(subPrice)}/${freq === '30' ? 'mo' : freq + ' days'}`;
        atcBtn.disabled  = false;
      } else {
        atcBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 6h12l-1.5 7.5H4.5L3 6z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="15" r="1" fill="currentColor"/><circle cx="12" cy="15" r="1" fill="currentColor"/><path d="M1 2h2l.5 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg> Add to Cart — ${formatMoney(rawPrice)}`;
        atcBtn.disabled  = false;
      }
    }
  }

  function updateVariantInput() {
    if (variantInput) variantInput.value = currentVariantId;
    // Recharge native: keep hidden selling_plan in sync with visible select
    // (form is submitted only via the hidden input).
    if (sellingPlan) {
      if (currentType === 'onetime') {
        sellingPlan.value = '';
      } else if (isNativeRecharge && sellingPlanSelect) {
        sellingPlan.value = sellingPlanSelect.value;
      }
      // Legacy Recharge mode: Recharge JS owns the value, we don't touch it on subscription mode.
    }
  }

  // Sync hidden selling-plan input whenever native plan select changes
  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', () => {
      if (sellingPlan && currentType === 'subscription') {
        sellingPlan.value = sellingPlanSelect.value;
      }
    });
  }

  // Variant buttons
  // - When tile is a sibling-product link (<a>), let it navigate normally
  // - When tile is a variant of the same product, do in-place update
  variantBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      // If it's a real link to a different product, allow default navigation
      if (btn.tagName === 'A' && btn.getAttribute('href') && !btn.dataset.variantId) {
        return;
      }
      e.preventDefault();
      variantBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const newId = parseInt(btn.dataset.variantId);
      if (!newId) return;
      currentVariantId = newId;

      // Sync gallery thumbnail
      const thumbIdx = Array.from(variantBtns).indexOf(btn);
      const thumbs   = document.querySelectorAll('.thumb');
      if (thumbs[thumbIdx]) thumbs[thumbIdx].click();

      updatePrice();
      updateVariantInput();

      // Update URL without reload (Shopify standard)
      const url = new URL(window.location);
      url.searchParams.set('variant', currentVariantId);
      window.history.replaceState({}, '', url);
    });
  });

  // Purchase type toggle
  if (purchaseToggle) {
    purchaseToggle.querySelectorAll('.purchase-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        purchaseToggle.querySelectorAll('.purchase-opt').forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        currentType = opt.dataset.type;
        if (frequencyRow) frequencyRow.classList.toggle('show', currentType === 'subscription');
        updatePrice();
        updateVariantInput();
        // Notify ReCharge of type change (ReCharge listens for this)
        document.dispatchEvent(new CustomEvent('optimind:purchase-type-changed', { detail: { type: currentType } }));
      });
    });
  }

  // Frequency change — either select drives price update
  if (frequencySelect) {
    frequencySelect.addEventListener('change', () => {
      updatePrice();
      document.dispatchEvent(new CustomEvent('optimind:frequency-changed', { detail: { frequency: frequencySelect.value } }));
    });
  }
  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', () => {
      updatePrice();
      document.dispatchEvent(new CustomEvent('optimind:selling-plan-changed', { detail: { plan: sellingPlanSelect.value } }));
    });
  }

  // Form submit — add to cart via fetch for SPA-feel
  const form = document.getElementById('product-form-' + (document.querySelector('[id^="product-form-"]')?.id?.split('-').pop() || ''));
  if (form) {
    form.addEventListener('submit', async (e) => {
      // Let ReCharge handle subscription submits if active
      if (currentType === 'subscription' && window.ReCharge) return; // ReCharge takes over
      e.preventDefault();
      const btn = atcBtn;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding…';
      btn.disabled  = true;
      try {
        const formData = new FormData(form);
        const resp = await fetch('/cart/add.js', { method: 'POST', body: formData });
        const data = await resp.json();
        if (data.id) {
          btn.innerHTML = '✓ Added to Cart!';
          setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
          // Update cart count in nav
          const countEl = document.querySelector('.cart-count');
          if (countEl) {
            const cartResp = await fetch('/cart.js');
            const cart     = await cartResp.json();
            countEl.textContent = cart.item_count;
            countEl.style.display = '';
          }
        }
      } catch (err) {
        btn.innerHTML = originalHTML;
        btn.disabled  = false;
        console.error('Cart add failed:', err);
      }
    });
  }

  // Init
  updatePrice();
  updateVariantInput();
})();

/* ── BLOG CATEGORY FILTER ── */
(function initBlogFilter() {
  const catBtns = document.querySelectorAll('.cat-btn');
  if (!catBtns.length) return;
  catBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      catBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const cat = btn.dataset.cat;
      document.querySelectorAll('.article-card').forEach(card => {
        const tags  = card.dataset.cat || '';
        const match = cat === 'all' || tags.includes(cat);
        card.style.display = match ? '' : 'none';
      });
    });
  });
})();

/* ── INGREDIENT BARS ── */
(function initIngBars() {
  document.querySelectorAll('.ing-fill').forEach(fill => {
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { fill.classList.add('go'); }
    }, { threshold: 0.3 }).observe(fill);
  });
})();

/* ── ANNOUNCEMENT BAR DISMISS ── */
(function initAnnDismiss() {
  const ann = document.querySelector('.ann');
  if (!ann) return;
  if (sessionStorage.getItem('ann-dismissed')) { ann.style.display = 'none'; return; }
  // Optional: add close button
})();

/* ── SMOOTH SCROLL FOR ANCHOR LINKS ── */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    const offset = 80;
    const top    = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

/* ── RECHARGE INTEGRATION HELPERS ──
   These events are dispatched by theme.js and can be listened to
   by ReCharge's widget script for two-way sync.

   ReCharge setup steps:
   1. Install ReCharge from Shopify App Store
   2. In ReCharge admin: Products → enable subscription for OptiMind variants
   3. Set delivery frequencies: 30, 45, 60 days
   4. Configure selling plans and discount percentage
   5. The widget auto-renders in #rc_widget_container
   6. Test with ReCharge's sandbox environment first
   7. For API access: ReCharge REST API at https://api.rechargeapps.com

   Key events emitted by this theme:
   - 'optimind:purchase-type-changed' → { type: 'onetime'|'subscription' }
   - 'optimind:frequency-changed'     → { frequency: '30'|'45'|'60' }
── */

/* ── PROBLEM → SOLUTION: pair highlight + SVG connectors + auto-cycle ── */
(function initProblemSolution() {
  const root = document.getElementById('problem-solution');
  if (!root) return;
  const probs = root.querySelectorAll('.ps-prob');
  const sols  = root.querySelectorAll('.ps-sol');
  const dots  = root.querySelectorAll('.ps-dot');
  const svg   = root.querySelector('#psSvg');
  if (!probs.length || !sols.length) return;

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let currentPair = 0;
  let autoTimer = null;
  let userActed = false;

  // Build SVG connectors
  function buildConnectors() {
    if (!svg) return;
    const wrap = root.querySelector('.ps-interactive');
    if (!wrap) return;
    const rect = wrap.getBoundingClientRect();
    svg.setAttribute('viewBox', `0 0 ${rect.width} ${rect.height}`);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.innerHTML = '';
    probs.forEach((p, i) => {
      const s = sols[i];
      if (!s) return;
      const pr = p.getBoundingClientRect();
      const sr = s.getBoundingClientRect();
      const x1 = pr.right - rect.left;
      const y1 = pr.top + pr.height / 2 - rect.top;
      const x2 = sr.left - rect.left;
      const y2 = sr.top + sr.height / 2 - rect.top;
      const cx = rect.width / 2;
      const cy = rect.height / 2;
      // Curve from problem → through center area → solution
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const d = `M${x1},${y1} Q${cx - 40},${y1} ${cx},${cy} Q${cx + 40},${y2} ${x2},${y2}`;
      path.setAttribute('d', d);
      path.dataset.pair = String(i);
      svg.appendChild(path);
    });
  }

  function setActive(idx) {
    currentPair = idx;
    probs.forEach((p, i) => p.classList.toggle('is-active', i === idx));
    sols.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    if (svg) svg.querySelectorAll('path').forEach((p, i) => p.classList.toggle('active', i === idx));
  }

  function startAuto() {
    if (reduced || userActed) return;
    stopAuto();
    autoTimer = setInterval(() => setActive((currentPair + 1) % probs.length), 3500);
  }
  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  probs.forEach((p, i) => {
    p.addEventListener('mouseenter', () => { userActed = true; stopAuto(); setActive(i); });
    p.addEventListener('focus',      () => { userActed = true; stopAuto(); setActive(i); });
    p.addEventListener('click',      () => { userActed = true; stopAuto(); setActive(i); });
    p.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(i); }
    });
  });
  sols.forEach((s, i) => {
    s.addEventListener('mouseenter', () => { userActed = true; stopAuto(); setActive(i); });
    s.addEventListener('click',      () => { userActed = true; stopAuto(); setActive(i); });
  });
  dots.forEach((d, i) => {
    d.addEventListener('click', () => { userActed = true; stopAuto(); setActive(i); });
  });

  // Entrance reveal — stagger cards in as section enters viewport
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        [...probs, ...sols].forEach((el, n) => {
          setTimeout(() => el.setAttribute('data-revealed', ''), n * 90);
        });
        // After reveal, build connectors and start auto-cycle
        setTimeout(() => { buildConnectors(); setActive(0); startAuto(); }, probs.length * 90 + 200);
        io.disconnect();
      }
    }, { threshold: 0.2 });
    io.observe(root);
  } else {
    [...probs, ...sols].forEach(el => el.setAttribute('data-revealed', ''));
    buildConnectors(); setActive(0); startAuto();
  }

  // Pause on root hover
  root.addEventListener('mouseleave', () => { if (!userActed) startAuto(); });

  // Rebuild connectors on resize
  let rt = null;
  window.addEventListener('resize', () => {
    clearTimeout(rt);
    rt = setTimeout(() => { buildConnectors(); setActive(currentPair); }, 150);
  });
})();

/* ── USE CASES: TAB SWITCHING + COUNTER ANIMATION + AUTO-ROTATE ── */
(function initUseCases() {
  const tabs    = document.querySelectorAll('#ucTabs .uc-tab');
  const panels  = document.querySelectorAll('.uc-right .uc-panel');
  if (!tabs.length || !panels.length) return;

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let currentIdx = 0;
  let autoTimer = null;
  let userInteracted = false;

  function animateCounter(el) {
    const target = parseFloat(el.dataset.target) || 0;
    const dur = 1100;
    const start = performance.now();
    function tick(now) {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3); // easeOutCubic
      el.textContent = Math.round(target * e);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = target;
    }
    el.textContent = '0';
    requestAnimationFrame(tick);
  }

  function activate(idx, fromUser) {
    if (idx === currentIdx && fromUser !== 'init') return;
    const dir = idx > currentIdx ? 1 : -1;
    currentIdx = idx;

    tabs.forEach(t => {
      const on = t.dataset.idx === String(idx);
      t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    // Slide animation: mark outgoing/incoming
    panels.forEach(p => {
      const wasActive = p.classList.contains('active');
      const isNew = p.dataset.idx === String(idx);
      if (wasActive && !isNew) {
        p.classList.remove('active');
        p.classList.add('uc-leave');
        p.style.setProperty('--uc-dir', dir);
        setTimeout(() => p.classList.remove('uc-leave'), 400);
      } else if (isNew) {
        p.classList.add('active');
        p.style.setProperty('--uc-dir', dir);
        // Restart counters every switch
        p.querySelectorAll('.uc-stat-val[data-target]').forEach(animateCounter);
      }
    });
  }

  function startAuto() {
    if (reduced || userInteracted) return;
    stopAuto();
    autoTimer = setInterval(() => {
      activate((currentIdx + 1) % tabs.length);
    }, 6500);
  }
  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      userInteracted = true;
      stopAuto();
      activate(parseInt(tab.dataset.idx, 10) || 0, 'user');
    });
    // Keyboard arrow nav
    tab.addEventListener('keydown', (e) => {
      const idx = parseInt(tab.dataset.idx, 10) || 0;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault(); userInteracted = true; stopAuto();
        const next = (idx + 1) % tabs.length;
        tabs[next].focus(); activate(next, 'user');
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault(); userInteracted = true; stopAuto();
        const prev = (idx - 1 + tabs.length) % tabs.length;
        tabs[prev].focus(); activate(prev, 'user');
      }
    });
  });

  // Animate first panel + start auto-rotate when section enters viewport
  const section = document.getElementById('use-cases-section');
  if (section && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        const first = document.querySelector('.uc-panel.active');
        if (first) first.querySelectorAll('.uc-stat-val[data-target]').forEach(animateCounter);
        startAuto();
      } else {
        stopAuto();
      }
    }, { threshold: 0.25 });
    io.observe(section);
  } else {
    // Fallback: immediate
    const first = document.querySelector('.uc-panel.active');
    if (first) first.querySelectorAll('.uc-stat-val[data-target]').forEach(animateCounter);
  }

  // Pause on hover
  const ucInner = document.querySelector('#use-cases-section .uc-inner');
  if (ucInner) {
    ucInner.addEventListener('mouseenter', stopAuto);
    ucInner.addEventListener('mouseleave', () => { if (!userInteracted) startAuto(); });
  }

  /* canvas — gentle particle field background */
  const canvas = document.getElementById('uc-canvas');
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d');
    let w, h, dots, raf;
    function resize() {
      w = canvas.width  = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
      dots = Array.from({ length: 38 }, () => ({
        x: Math.random()*w, y: Math.random()*h,
        vx: (Math.random()-.5)*.25, vy: (Math.random()-.5)*.25,
        r: Math.random()*1.6 + .6
      }));
    }
    function draw() {
      ctx.clearRect(0,0,w,h);
      ctx.fillStyle = 'rgba(120,180,255,.35)';
      dots.forEach(d => {
        d.x += d.vx; d.y += d.vy;
        if (d.x<0||d.x>w) d.vx*=-1;
        if (d.y<0||d.y>h) d.vy*=-1;
        ctx.beginPath(); ctx.arc(d.x,d.y,d.r,0,Math.PI*2); ctx.fill();
      });
      // connecting lines
      ctx.strokeStyle = 'rgba(120,180,255,.08)';
      ctx.lineWidth = 1;
      for (let i=0;i<dots.length;i++) for (let j=i+1;j<dots.length;j++) {
        const dx = dots[i].x-dots[j].x, dy = dots[i].y-dots[j].y;
        const d = Math.sqrt(dx*dx+dy*dy);
        if (d < 110) {
          ctx.globalAlpha = 1 - d/110;
          ctx.beginPath();
          ctx.moveTo(dots[i].x,dots[i].y);
          ctx.lineTo(dots[j].x,dots[j].y);
          ctx.stroke();
        }
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    }
    resize();
    draw();
    window.addEventListener('resize', () => { cancelAnimationFrame(raf); resize(); draw(); });
  }
})();

/* ── INGREDIENT NEURAL NETWORK: orbit nodes + synaptic pulses + hover ── */
(function initIngNetwork() {
  const root = document.getElementById('ingNetwork');
  if (!root) return;
  let data;
  try { data = JSON.parse(root.dataset.ingredients || '[]'); } catch (e) { return; }
  if (!data.length) return;

  const linesG = root.querySelector('#ingNetLines');
  const pulsesG = root.querySelector('#ingNetPulses');
  const nodesG = root.querySelector('#ingNetNodes');
  const tip    = root.querySelector('#ingNetTip');
  const tipName = tip && tip.querySelector('.ing-net-tip-name');
  const tipTag  = tip && tip.querySelector('.ing-net-tip-tag');
  if (!linesG || !pulsesG || !nodesG) return;

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const svgNS = 'http://www.w3.org/2000/svg';
  const cx = 240, cy = 240;
  const N = data.length;
  const positions = [];
  let activeIdx = -1;

  // Position 12 nodes on two interleaved rings for organic feel
  for (let i = 0; i < N; i++) {
    const ring = i % 2 === 0 ? 0 : 1;
    const r = ring === 0 ? 175 : 145;
    const angleOffset = ring === 0 ? -Math.PI / 2 : -Math.PI / 2 + Math.PI / N;
    const a = angleOffset + (i / N) * Math.PI * 2;
    positions.push({ x: cx + Math.cos(a) * r, y: cy + Math.sin(a) * r, angle: a, r });
  }

  // Build connector lines (center → node)
  positions.forEach((p, i) => {
    const path = document.createElementNS(svgNS, 'path');
    // Slight curve so it doesn't look like radiating bicycle spokes
    const mx = (cx + p.x) / 2 + Math.cos(p.angle + Math.PI / 2) * 8;
    const my = (cy + p.y) / 2 + Math.sin(p.angle + Math.PI / 2) * 8;
    path.setAttribute('d', 'M' + cx + ',' + cy + ' Q' + mx + ',' + my + ' ' + p.x + ',' + p.y);
    path.dataset.idx = String(i);
    linesG.appendChild(path);
  });

  // Build interactive nodes
  positions.forEach((p, i) => {
    const g = document.createElementNS(svgNS, 'g');
    g.setAttribute('class', 'ing-net-node');
    g.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')');
    g.dataset.idx = String(i);
    g.setAttribute('tabindex', '0');
    g.setAttribute('role', 'button');
    g.setAttribute('aria-label', data[i].n + ' — ' + data[i].t);

    const pulse = document.createElementNS(svgNS, 'circle');
    pulse.setAttribute('class', 'ing-net-node-pulse');
    pulse.setAttribute('r', '14');
    pulse.style.animationDelay = (i * 0.25) + 's';
    g.appendChild(pulse);

    const ring = document.createElementNS(svgNS, 'circle');
    ring.setAttribute('class', 'ing-net-node-ring');
    ring.setAttribute('r', '14');
    g.appendChild(ring);

    const dot = document.createElementNS(svgNS, 'circle');
    dot.setAttribute('class', 'ing-net-node-dot');
    dot.setAttribute('r', '5');
    g.appendChild(dot);

    nodesG.appendChild(g);
  });

  const allNodes = nodesG.querySelectorAll('.ing-net-node');
  const allLines = linesG.querySelectorAll('path');

  function showTip(i) {
    if (!tip) return;
    tipName.textContent = data[i].n;
    tipTag.textContent = data[i].t;
    tip.classList.add('show');
  }
  function hideTip() { tip && tip.classList.remove('show'); }

  function setActive(i) {
    activeIdx = i;
    allNodes.forEach((n, k) => {
      n.classList.toggle('is-active', k === i);
      n.classList.toggle('is-dim', i !== -1 && k !== i);
    });
    allLines.forEach((l, k) => {
      l.classList.toggle('is-active', k === i);
      l.classList.toggle('is-dim', i !== -1 && k !== i);
    });
    if (i >= 0) showTip(i); else hideTip();
  }

  allNodes.forEach((node, i) => {
    node.addEventListener('mouseenter', () => setActive(i));
    node.addEventListener('focus',      () => setActive(i));
    node.addEventListener('mouseleave', () => setActive(-1));
    node.addEventListener('blur',       () => setActive(-1));
    node.addEventListener('click', () => setActive(i === activeIdx ? -1 : i));
    node.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(i === activeIdx ? -1 : i); }
    });
  });

  // Fire a synapse pulse along a random line periodically
  function firePulse(lineIdx) {
    if (reduced) return;
    const idx = lineIdx == null ? Math.floor(Math.random() * positions.length) : lineIdx;
    const target = positions[idx];
    const pulse = document.createElementNS(svgNS, 'circle');
    pulse.setAttribute('class', 'ing-net-pulse');
    pulse.setAttribute('r', '3.5');
    pulse.setAttribute('cx', String(cx));
    pulse.setAttribute('cy', String(cy));
    pulsesG.appendChild(pulse);

    const dur = 700 + Math.random() * 400;
    const start = performance.now();
    function step(now) {
      const t = Math.min(1, (now - start) / dur);
      // Quadratic Bezier interp matching the connector curve
      const mx = (cx + target.x) / 2 + Math.cos(target.angle + Math.PI / 2) * 8;
      const my = (cy + target.y) / 2 + Math.sin(target.angle + Math.PI / 2) * 8;
      const it = 1 - t;
      const x = it * it * cx + 2 * it * t * mx + t * t * target.x;
      const y = it * it * cy + 2 * it * t * my + t * t * target.y;
      pulse.setAttribute('cx', String(x));
      pulse.setAttribute('cy', String(y));
      pulse.style.opacity = String(t < .85 ? 1 : (1 - (t - .85) / .15));
      if (t < 1) requestAnimationFrame(step);
      else pulsesG.removeChild(pulse);
    }
    requestAnimationFrame(step);
  }

  if (!reduced) {
    // Initial burst when section enters view
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          // Stagger initial pulses
          positions.forEach((_, i) => setTimeout(() => firePulse(i), 80 * i));
          io.disconnect();
        }
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      positions.forEach((_, i) => setTimeout(() => firePulse(i), 80 * i));
    }

    // Continuous pulses
    setInterval(() => {
      if (document.hidden) return;
      // Fire 1-3 pulses simultaneously
      const burst = 1 + Math.floor(Math.random() * 2);
      for (let k = 0; k < burst; k++) {
        setTimeout(() => firePulse(activeIdx >= 0 ? activeIdx : null), k * 120);
      }
    }, 1100);
  }
})();


/* ─────────── GLOBAL SCROLL REVEAL + ANIMATED COUNTERS ─────────── */
(function(){
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Scroll reveal — apply to common section roots automatically + any element with .reveal-on-scroll
  function markReveal(el){
    if (!el || el.classList.contains('reveal-on-scroll') || el.dataset.noReveal === 'true') return;
    el.classList.add('reveal-on-scroll');
  }
  // Auto-tag major section roots (skip the hero which has its own animation)
  var autoSelectors = [
    '#problem-solution .ps-card',
    '#benefits .ben-card',
    '#expectation-timeline .et-row',
    '#ingredients .ing-card',
    '#comp-table',
    '#science-strip .ss-card',
    '#use-cases .uc-card',
    '#dosage-protocol .dp-step',
    '#trust .trust-card, #trust .tile-trust',
    '#social-proof .sp-card',
    '#testimonials .test-card',
    '#pricing .pr-card',
    '#faq .faq-q'
  ];
  try {
    document.querySelectorAll(autoSelectors.join(',')).forEach(function(el, i){
      markReveal(el);
      // Stagger delays per-item within a parent (max 6 items deep)
      if (!el.style.getPropertyValue('--delay')) {
        var sibIdx = Array.prototype.indexOf.call(el.parentNode.children, el) % 6;
        el.style.setProperty('--delay', (sibIdx * 0.08) + 's');
      }
    });
  } catch(e){}

  var revealItems = document.querySelectorAll('.reveal-on-scroll');
  if (revealItems.length && !reduced) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealItems.forEach(function(el){ io.observe(el); });
  } else if (reduced) {
    revealItems.forEach(function(el){ el.classList.add('is-visible'); });
  }

  // 2) Animated number counters — elements with [data-counter]
  var counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;

  function animateCounter(el){
    var target = parseFloat(el.getAttribute('data-counter'));
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) return;
    if (reduced){
      el.innerHTML = (Number.isInteger(target) ? target : target.toFixed(1)) + (suffix ? '<em>' + suffix + '</em>' : '');
      return;
    }
    var dur = 1400;
    var start = performance.now();
    var isInt = Number.isInteger(target);
    function frame(now){
      var t = Math.min((now - start) / dur, 1);
      // ease-out-cubic
      var eased = 1 - Math.pow(1 - t, 3);
      var val = target * eased;
      var rendered = isInt ? Math.round(val) : val.toFixed(1);
      el.innerHTML = rendered + (suffix ? '<em>' + suffix + '</em>' : '');
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (reduced){
    counters.forEach(animateCounter);
    return;
  }
  var cio = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        animateCounter(entry.target);
        cio.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  counters.forEach(function(el){ cio.observe(el); });
})();

/* ─────────── CONTINUOUS LOOP ANIMATIONS (applied to homepage sections) ─────────── */
(function(){
  if (typeof document === 'undefined') return;
  // Only run on homepage to avoid touching cart/product/etc
  var isHome = document.body && document.body.classList.contains('template-index');
  if (!isHome) {
    // Fallback: detect by presence of the hero
    if (!document.querySelector('#opti-hero, .opti-hero, #optimind-hero')) {
      // run anyway if any of the listed sections exist
      if (!document.querySelector('#problem-solution, #benefits, #ingredients, #trust, #testimonials, #pricing, #faq')) return;
    }
  }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  // 1) Add ambient glow to every major homepage section root
  var sectionRoots = [
    '#problem-solution','#benefits','#expectation-timeline','#ingredients',
    '#competitor-comparison','#science-strip','#use-cases','#dosage-protocol',
    '#trust','#social-proof','#testimonials','#pricing','#faq'
  ];
  sectionRoots.forEach(function(sel){
    var el = document.querySelector(sel);
    if (el && !el.classList.contains('section-amb')) el.classList.add('section-amb');
  });

  // 2) Apply rotating loop animations to all cards so the whole page is in continuous motion
  //    Each card gets one of [float, float-2, sway, pulse, tilt] based on index; plus a delay offset so they don't all peak at once.
  var loopClasses = ['loop-float','loop-float-2','loop-sway','loop-pulse','loop-tilt'];
  var cardSelectors = [
    '#problem-solution .ps-card',
    '#benefits .ben-card',
    '#expectation-timeline .et-row',
    '#ingredients .ing-card',
    '#science-strip .ss-card',
    '#use-cases .uc-card',
    '#dosage-protocol .dp-step',
    '#trust .trust-card, #trust .tile-trust',
    '#social-proof .sp-card',
    '#testimonials .test-card',
    '#pricing .pr-card'
  ];
  cardSelectors.forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el, i){
      var cls = loopClasses[i % loopClasses.length];
      el.classList.add(cls);
      // negative delay so each card is at a different point in its loop
      el.style.animationDelay = '-' + ((i * 0.7) % 6).toFixed(2) + 's';
    });
  });

  // 3) Shimmer pass across pricing + testimonial cards (premium feel)
  document.querySelectorAll('#pricing .pr-card, #testimonials .test-card, #social-proof .sp-card').forEach(function(el, i){
    el.classList.add('loop-shimmer');
    var shimmer = el.querySelector('.loop-shimmer-pseudo'); // pseudo not addressable, skip
    el.style.setProperty('--loop-shimmer-delay', (i * 0.8).toFixed(2) + 's');
  });

  // 4) Ingredient cards: animated conic border (extra premium)
  document.querySelectorAll('#ingredients .ing-card').forEach(function(el, i){
    el.classList.add('loop-border');
  });

  // 5) Sweep highlight across benefit + use-case grids
  ['#benefits .ben-grid','#use-cases .uc-grid','#ingredients .ing-grid','#science-strip .ss-grid'].forEach(function(sel){
    var g = document.querySelector(sel);
    if (g) g.classList.add('loop-sweep');
  });

  // 6) Pulse the section eyebrow labels (continuous gradient flow already in CSS)
  // (handled purely via .section-lbl rule)

  // 7) Pause animations when tab is hidden (battery-friendly)
  document.addEventListener('visibilitychange', function(){
    document.body.classList.toggle('anims-paused', document.hidden);
  });
})();
